import { render, staticRenderFns } from "./RecWish.vue?vue&type=template&id=0a3a7dbc&scoped=true"
import script from "./RecWish.vue?vue&type=script&lang=js"
export * from "./RecWish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3a7dbc",
  null
  
)

export default component.exports